<template>
  <f7-page resizable>
    <navbar :text="$t('LeftPanel_subtitle_home')" />
    <HomeProject />
  </f7-page>
</template>

<script>

import navbar from '../../components/navbar/NavBar.vue';
import HomeProject from '../../components/homeProject/index.vue';

export default {
  name: 'CockpitPage',
  components: {
    navbar,
    HomeProject,
  },

  computed: {
    currentURL() {
      return this.$f7route.url;
    },
  },

};
</script>

<style lang="scss">

</style>
